import { useMemo } from "react";
import { useQuery } from "react-query";

import { getVideos, Video } from "@/api/content.ts";

export const useVideos = ({ ids }: { ids: number[] }) => {
  const query = useQuery(
    ["videos", ids.join(",")],
    () => {
      return getVideos(ids);
    },
    { enabled: ids && ids.length > 0 },
  );

  const videoById = useMemo(() => {
    if (!ids || ids.length === 0) {
      return {} as Record<number, Video>;
    }

    if (!query.data) {
      return undefined;
    }

    const videoById: Record<number, Video> = {};
    for (const video of query.data) {
      videoById[video.VideoId] = {
        ...video,
      };
    }
    return videoById;
  }, [query.data, ids]);

  return { ...query, videoById, videos: query.data };
};
